import styled from 'styled-components';

import { PayrunListItem } from '@xemplo/gp-types';
import {
  BodySmallMedium,
  BodyXSmallMedium,
  BodyXSmallRegular,
  BodyXSmallSemiBold,
  Colour,
  TextEllipsis,
} from '@xemplo/style-constants';
import { XemploTable } from '@xemplo/table';
import { Tooltip } from '@xemplo/tooltip';

export const Container = styled.div`
  padding: 32px;
`;

export const PayrunListTable = styled(XemploTable<PayrunListItem>)`
  background: transparent;
  ${BodyXSmallRegular};
  color: ${Colour.Clarity.Content.Soft};
  .action-bar-container {
    border-radius: 8px;
    position: relative;
    box-sizing: content-box;
  }
  table {
    background: transparent;
    thead {
      border: none;
      color: ${Colour.Clarity.Content.Soft};
      ${BodyXSmallMedium};
      th {
        & > div {
          white-space: normal;
        }
      }
    }

    tbody {
      background: transparent;

      ${BodyXSmallRegular};
      tr {
        box-sizing: border-box;
        background: ${Colour.Clarity.Background.Surface};
        margin-bottom: 8px;
        border-radius: 8px;
        height: 76px;
        border: 1px solid transparent;
        cursor: pointer;
        &.active {
          box-sizing: border-box;
          border-radius: 8px;
          border: 1px solid ${Colour.Clarity.Blue.Hard};
          background: rgba(11, 120, 255, 0.08);
        }
      }
      td {
        &:first-child {
          color: ${Colour.Clarity.Content.Medium};
          ${BodySmallMedium};
        }
      }
    }
  }
`;

export const PayrunIcon = styled.div`
  position: relative;
  && {
    overflow: visible;
  }
  display: flex;
  height: 36px;
  width: 36px;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  background: ${Colour.Clarity.Purple.ExtraSoft};
  flex-grow: 0;
  flex-shrink: 0;
  > svg {
    width: 20px;
    height: 20px;
    color: ${Colour.Clarity.Purple.Hard};
  }
  &.adhoc {
    background: ${Colour.Clarity.Blue.ExtraSoft};
    > svg {
      color: ${Colour.Clarity.Blue.Hard};
    }
  }
`;

export const PayrunSystemBadge = styled.span`
  position: absolute;
  right: -4px;
  bottom: -4px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: ${Colour.Clarity.Background.Surface};
  border: 1px solid ${Colour.Clarity.Grey.Soft};
  box-sizing: border-box;
  > svg {
    width: auto;
    height: 7px;
  }
`;

export const TrunctatedText = styled.div`
  ${TextEllipsis};
`;

export const InlineTooltip = styled(Tooltip)`
  display: inline-block;
`;

export const PayrunNameCell = styled.div`
  && {
    overflow: visible;
  }
  display: flex;
  gap: 16px;
  align-items: center;
  ${BodySmallMedium};
  width: 100%;
`;

export const PayrunNameContent = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 0;
  & > div {
    ${TextEllipsis};
  }
`;

export const PayrunTypeLabel = styled.div`
  ${BodyXSmallRegular};
  color: ${Colour.Clarity.Content.Soft};
  ${TextEllipsis};
`;

export const MilestoneDueDateCellWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const MilestoneDueDate = styled.div`
  ${BodyXSmallSemiBold};
  color: ${Colour.Clarity.Content.Soft};
  &.due {
    color: ${Colour.Clarity.Orange.Hard};
  }
  &.overdue {
    color: ${Colour.Clarity.Red.Hard};
  }
`;

export const MilestoneDateSubtext = styled.div`
  ${BodyXSmallRegular};
  color: ${Colour.Clarity.Content.Soft};
`;

export const RightAlign = styled.div`
  text-align: right;
  width: 100%;
`;
